import { AgencyAgent } from '@/types-agency';
import { Listing } from '@smg-real-estate/hg-rets-schema';

export type AgencyAgentType = Pick<AgencyAgent, 'avatarUrl' | 'email' | 'firstName' | 'lastName'>;

export interface ReferenceListing extends Listing {
  agencyAgent?: AgencyAgentType;
}

export enum ReferenceListingModalMode {
  ADD = 'ADD',
  EDIT = 'EDIT',
}

export enum ApiCallStatus {
  READY = 'READY',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
